import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useIDCONSELHOChartsDataContext } from './hooks/useIDCONSELHOChartsDataContext';

export const CouncilCompositionEvolutionChart = () => {
    const { chartData } = useIDCONSELHOChartsDataContext();

    return (
        <SimpleBars
            title="Evolução Anual da Composição do Conselho"
            subtitles={chartData.councilComposition.map((item) => getYearLabel(item.ano))}
            values={chartData.councilComposition.map(
                (item) => Number(item.composicao_conselho) || 0
            )}
        />
    );
};
